module.exports = __webpack_public_path__ + "static/img/ovo.8eb8978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ovo.png
// module id = /N72
// module chunks = 1